// import axios from "axios";
import { useState, useEffect } from "react";
import choices from "./choices.json";
// import { useQuery } from "react-query";
// import { baseURL } from "@helper/interceptor";

// async function getChoices() {
//   const response = axios.get(`${baseURL}static/choices.json`);
//   return response;
// }

export default function useChoices(x) {
  const [choiceType, setChoiceType] = useState(x);
  const [choicedata, setChoiceData] = useState<Array<{ key: string; value: any }> | undefined>();

  useEffect(() => {
    if (!choiceType) return;

    const filtered = choices[choiceType];
    if (filtered) {
      const val = Object.keys(filtered).map((key) => ({
        key,
        value: filtered[key],
      }));
      setChoiceData(val);
    } else {
      setChoiceData(undefined);
    }
  }, [choiceType]);

  const setChoice = (val: string) => {
    setChoiceType(val);
  };

  //   let choices = data.data;

  //   let filtered = Object.values(
  //     Object.fromEntries(Object.entries(choices).filter((key) => key[0] === choiceType))
  //   );
  //   if (filtered.length > 0) {
  //     let val =
  //       filtered &&
  //       Object.keys(filtered[0]).map((key) => {
  //         return { key: key, value: filtered[0][key] };
  //       });
  //     setChoiceData(val);
  //   }
  // },

  return [choicedata, setChoice];
}
